module.exports = __webpack_public_path__ + "img/slimfit.9894f5fd.png";